<template lang="pug">
#app
	header.header-top
		.container
			.row.d-flex.justify-items-end
				.menu.d-flex.w-100
					li.p-2
						router-link(to="/business") Para Negocios
					li.p-2
						router-link(to="/student") Para Alumnos
					li.p-2.float-right.ml-auto
						a(href='mailto:hola@boxmagic.cl') hola@boxmagic.cl
	
	transition(name="fade")
		router-view
			
</template>

<script>

	export default {
		name: 'App',
		data() {
			return {
				prevHeight: 0
			};
		},
		methods: {
			beforeLeave(element) {
				this.prevHeight = getComputedStyle(element).height;
			},
			enter(element) {
				const { height } = getComputedStyle(element);

				element.style.height = this.prevHeight;

				setTimeout(() => {
					element.style.height = height;
				});
			},
			afterEnter(element) {
				element.style.height = 'auto';
			},
		},

	};
</script>

<style lang="scss">
	@import "assets/scss/style";
</style>
